import { useSearchParams } from 'react-router-dom';

export const useSearchParamsUpdater = <T>() => {
  const [searchParams, setSearchParams] = useSearchParams();

  const updateSearchParams = (updates: Partial<T>) => {
    setSearchParams((prev) => {
      for (const [key, value] of Object.entries(updates)) {
        if (value !== undefined && value !== null && value !== '') {
          prev.set(key, value.toString());
        } else {
          prev.delete(key);
        }
      }
      return prev;
    });
  };

  return { searchParams, updateSearchParams };
};
